module.exports = __webpack_public_path__ + "img/ying.ae9370ab.png";